import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "editor edgeEditor" }
const _hoisted_2 = { class: "edgeTitle" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = ["disabled", "pattern"]
const _hoisted_6 = ["disabled", "pattern"]

import { ref, computed, watch } from "vue"
import { Transition } from "@/assets/types"
import { csv } from "@/assets/predefined";
import { parseList } from "@/assets/utilities";


export default /*#__PURE__*/_defineComponent({
  props: {
    edgeId: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    edgeId: string;
    modelValue: Transition;
}




const ruleType = ref<Transition["ruleType"]>("ALL");
const charset = ref<string[]>([])
const includeText = ref<string>("")
const excludeText = ref<string>("")

const charsetText = computed<string>({
    set(val: string) {
        // console.log(val)
        if (ruleType.value === "INCLUDE" && csv.test(val)) {
            charset.value = parseList(val);
        }
        else if (ruleType.value === "EXCLUDE" && csv.test(val)) {
            charset.value = parseList(val);
        }
        else if (ruleType.value === "ALL" || ruleType.value === "EPSILON" || val===""   ) {
            charset.value = [];
        }
    },
    get() {
        return charset.value.toString()
    }
})

updateModel()
const label = computed(() => {
    if (ruleType.value === "INCLUDE") {
        return charsetText.value;
    }
    else if (ruleType.value === "EXCLUDE") {
        return (charset.value.length !== 0) ? "¬" + charset.value.join(", ¬") : "";
    } else if (ruleType.value === "EPSILON") {
        return "ε"
    }

    return "*";

})

const edge = computed<Transition>(() => {
    return {
        source: props.modelValue.source,
        target: props.modelValue.target,
        label: label.value,
        ruleType: ruleType.value,
        charset: charset.value
    }
})

function updateModel() {
    ruleType.value = props.modelValue.ruleType
    if (props.modelValue.ruleType === 'INCLUDE'){
        includeText.value = props.modelValue.charset.join(",")
        excludeText.value = ""
        charsetText.value = includeText.value

    } else {
        excludeText.value = props.modelValue.charset.join(",")
        includeText.value = ""
        charsetText.value = excludeText.value
    }
    console.log(props.edgeId, props.modelValue)

}

watch(label, async () => 
    emits("update:modelValue", edge.value)
)
watch(() => props.edgeId, async () => updateModel())
watch(ruleType,async () => {
    if (ruleType.value === "EXCLUDE") {
        charsetText.value = excludeText.value
    } else if (ruleType.value === "INCLUDE") {
        charsetText.value = includeText.value
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(__props.modelValue.source) + " → " + _toDisplayString(__props.modelValue.target), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (ruleType.value = 'EPSILON'))
      }, "ε-transition"),
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        value: "EPSILON",
        id: "ruleTypeEPSILON",
        name: "ruleType",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleType).value = $event))
      }, null, 512), [
        [_vModelRadio, ruleType.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (ruleType.value = 'ALL'))
      }, "All alphabet"),
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        value: "ALL",
        id: "ruleTypeALL",
        name: "ruleType",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleType).value = $event))
      }, null, 512), [
        [_vModelRadio, ruleType.value]
      ])
    ]),
    _createElementVNode("div", {
      class: "section",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (ruleType.value = 'EXCLUDE'))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Exclude characters",
        disabled: ruleType.value != 'EXCLUDE',
        pattern: _unref(csv).source,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((excludeText).value = $event)),
        onInput: _cache[5] || (_cache[5] = ($event: any) => (charsetText.value = $event.target.value))
      }, null, 40, _hoisted_5), [
        [_vModelText, excludeText.value]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        value: "EXCLUDE",
        id: "ruleTypeEXCLUDE",
        name: "ruleType",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ruleType).value = $event))
      }, null, 512), [
        [_vModelRadio, ruleType.value]
      ])
    ]),
    _createElementVNode("div", {
      class: "section",
      onClick: _cache[11] || (_cache[11] = ($event: any) => (ruleType.value = 'INCLUDE'))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Include characters",
        disabled: ruleType.value != 'INCLUDE',
        pattern: _unref(csv).source,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((includeText).value = $event)),
        onInput: _cache[9] || (_cache[9] = ($event: any) => (charsetText.value = $event.target.value))
      }, null, 40, _hoisted_6), [
        [_vModelText, includeText.value]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        value: "INCLUDE",
        id: "ruleTypeINCLUDE",
        name: "ruleType",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ruleType).value = $event))
      }, null, 512), [
        [_vModelRadio, ruleType.value]
      ])
    ])
  ]))
}
}

})